"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCustom = exports.serializeCustom = void 0;
const serializeCustom = (item) => {
    return typeof item.data.stringValue === "string" ? item.data.stringValue : "";
};
exports.serializeCustom = serializeCustom;
const validateCustom = (item) => {
    const hasData = Object.values(item.data || {}).filter(Boolean).length > 0;
    if (!item.required || hasData) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must be filled out." } };
};
exports.validateCustom = validateCustom;
//# sourceMappingURL=custom.js.map